// components/Cart/CheckoutForm.js

import React, { useEffect } from 'react';
import contacts from '../../data/contacts.json';

const CheckoutForm = ({
  darkMode,
  formData,
  handleFormChange,
  handleDeliveryMethodChange,
  handleSubmitOrder,
  setCheckoutStep,
  calculateTotal,
  calculateDeliveryPrice,
  getPaymentMethod
}) => {
  // Добавляем обработчик маски телефона
  const handlePhoneInput = (e) => {
    const { value } = e.target;
    const phoneNumber = value.replace(/\D/g, '');

    let formattedPhone = '+7';
    if (phoneNumber.length > 1) {
      formattedPhone += ' (' + phoneNumber.substring(1, 4);
    }
    if (phoneNumber.length > 4) {
      formattedPhone += ') ' + phoneNumber.substring(4, 7);
    }
    if (phoneNumber.length > 7) {
      formattedPhone += '-' + phoneNumber.substring(7, 9);
    }
    if (phoneNumber.length > 9) {
      formattedPhone += '-' + phoneNumber.substring(9, 11);
    }

    // Обновляем значение в formData
    const event = {
      target: {
        name: 'phone',
        value: formattedPhone
      }
    };
    handleFormChange(event);
  };

  // Обработчик для ограничения ввода только цифр и форматирования
  const handlePhoneKeyDown = (e) => {
    // Разрешаем: backspace, delete, tab, escape, enter, цифры
    if (
      [8, 9, 27, 13, 46].indexOf(e.keyCode) !== -1 ||
      // Разрешаем: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
      (e.ctrlKey === true && [65, 67, 86, 88].indexOf(e.keyCode) !== -1) ||
      // Разрешаем: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
      return;
    }

    // Запрещаем все, кроме цифр
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  };

  return (
    <form onSubmit={handleSubmitOrder}>
      <h2 className={`text-xl font-bold mb-4 ${darkMode ? 'text-white' : ''}`}>Оформление заказа</h2>

      <div className={`rounded-lg shadow p-4 mb-6 ${darkMode ? 'bg-gray-800 text-white' : 'bg-white'}`}>
        <h3 className="font-semibold mb-4">Контактная информация</h3>

        <div className="mb-4">
          <label htmlFor="fullName" className="block mb-2 text-sm font-medium">
            Ф.И.О <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            id="fullName"
            name="fullName"
            value={formData.fullName}
            onChange={handleFormChange}
            required
            className={`w-full p-3 border rounded-lg ${darkMode
              ? 'bg-gray-700 border-gray-600 text-white'
              : 'bg-white border-gray-300'
              }`}
            aria-required="true"
          />
        </div>

        <div className="mb-4">
          <label htmlFor="phone" className="block mb-2 text-sm font-medium">
            Телефон <span className="text-red-500">*</span>
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handlePhoneInput}
            onKeyDown={handlePhoneKeyDown}
            required
            placeholder="+7 (___) ___-__-__"
            className={`w-full p-3 border rounded-lg ${darkMode
              ? 'bg-gray-700 border-gray-600 text-white'
              : 'bg-white border-gray-300'
              }`}
            aria-required="true"
          />
        </div>

        <div className="mb-4">
          <label htmlFor="telegramUsername" className="block mb-2 text-sm font-medium">
            Логин в Telegram
          </label>
          <div className="relative">
            <span className={`absolute left-3 top-3 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>@</span>
            <input
              type="text"
              id="telegramUsername"
              name="telegramUsername"
              value={formData.telegramUsername}
              onChange={handleFormChange}
              placeholder="username"
              className={`w-full p-3 pl-8 border rounded-lg ${darkMode
                ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-500'
                : 'bg-white border-gray-300 placeholder-gray-400'
                }`}
              aria-describedby="telegram-hint"
            />
          </div>
          <p id="telegram-hint" className={`text-xs mt-1 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
            Необязательно. Укажите для связи через Telegram.
          </p>
        </div>
      </div>

      {/* Остальной код компонента остается без изменений */}
      <div className={`rounded-lg shadow p-4 mb-6 ${darkMode ? 'bg-gray-800 text-white' : 'bg-white'}`}>
        <h3 className="font-semibold mb-4">Способ доставки</h3>

        <div
          className={`p-4 mb-3 border rounded-lg cursor-pointer ${formData.deliveryMethod === 'pickup'
            ? (darkMode ? 'border-blue-500 bg-blue-900 bg-opacity-20' : 'border-blue-500 bg-blue-50')
            : (darkMode ? 'border-gray-700' : 'border-gray-300')
            }`}
          onClick={() => handleDeliveryMethodChange('pickup')}
          role="radio"
          aria-checked={formData.deliveryMethod === 'pickup'}
          tabIndex="0"
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleDeliveryMethodChange('pickup');
            }
          }}
        >
          <div className="flex justify-between items-center mb-2">
            <h4 className="font-medium">Самовывоз</h4>
            <span className="font-bold text-green-500">Бесплатно</span>
          </div>
          <p className={darkMode ? 'text-gray-300' : 'text-gray-600'}>
            Вы можете самостоятельно забрать заказ из нашего магазина по адресу: <strong>{contacts.address.city}, {contacts.address.street}</strong>
          </p>
        </div>

        <div
          className={`p-4 mb-3 border rounded-lg cursor-pointer ${formData.deliveryMethod === 'courier'
            ? (darkMode ? 'border-blue-500 bg-blue-900 bg-opacity-20' : 'border-blue-500 bg-blue-50')
            : (darkMode ? 'border-gray-700' : 'border-gray-300')
            }`}
          onClick={() => handleDeliveryMethodChange('courier')}
          role="radio"
          aria-checked={formData.deliveryMethod === 'courier'}
          tabIndex="0"
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleDeliveryMethodChange('courier');
            }
          }}
        >
          <div className="flex justify-between items-center mb-2">
            <h4 className="font-medium">Доставка курьером</h4>
            <span className="font-bold text-green-500">
              {calculateTotal() >= 10000 ? 'Бесплатно' : '500 ₽'}
            </span>
          </div>
          <p className={darkMode ? 'text-gray-300' : 'text-gray-600'}>
            В пределах МКАД:<br />
            Заказ до 9 999 ₽ – 500 ₽.<br />
            Заказ от 10 000 ₽ – бесплатно.
          </p>

          {formData.deliveryMethod === 'courier' && (
            <div className="mt-4">
              <div className="mb-4">
                <label htmlFor="address" className="block mb-2 text-sm font-medium">
                  Адрес доставки <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleFormChange}
                  required={formData.deliveryMethod === 'courier'}
                  className={`w-full p-3 border rounded-lg ${darkMode
                    ? 'bg-gray-700 border-gray-600 text-white'
                    : 'bg-white border-gray-300'
                    }`}
                  aria-required={formData.deliveryMethod === 'courier' ? "true" : "false"}
                />
              </div>
            </div>
          )}
        </div>

        <div
          className={`p-4 border rounded-lg cursor-pointer ${formData.deliveryMethod === 'transport'
            ? (darkMode ? 'border-blue-500 bg-blue-900 bg-opacity-20' : 'border-blue-500 bg-blue-50')
            : (darkMode ? 'border-gray-700' : 'border-gray-300')
            }`}
          onClick={() => handleDeliveryMethodChange('transport')}
          role="radio"
          aria-checked={formData.deliveryMethod === 'transport'}
          tabIndex="0"
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleDeliveryMethodChange('transport');
            }
          }}
        >
          <div className="flex justify-between items-center mb-2">
            <h4 className="font-medium">Доставка транспортной компанией</h4>
            <span className="font-bold text-green-500">Бесплатно до ТК</span>
          </div>
          <p className={darkMode ? 'text-gray-300' : 'text-gray-600'}>
            Стоимость доставки до терминала ТК – бесплатно.<br />
            Стоимость доставки до города получателя оплачивается в офисе ТК.
          </p>
        </div>
      </div>

      <div className={`rounded-lg shadow p-4 mb-6 ${darkMode ? 'bg-gray-800 text-white' : 'bg-white'}`}>
        <h3 className="font-semibold mb-4">Комментарии к заказу</h3>
        <label htmlFor="comments" className="sr-only">Комментарии к заказу</label>
        <textarea
          id="comments"
          name="comments"
          value={formData.comments}
          onChange={handleFormChange}
          rows="3"
          className={`w-full p-3 border rounded-lg ${darkMode
            ? 'bg-gray-700 border-gray-600 text-white'
            : 'bg-white border-gray-300'
            }`}
          placeholder="Дополнительная информация к заказу..."
        ></textarea>
      </div>

      <div className={`rounded-lg shadow p-4 mb-6 ${darkMode ? 'bg-gray-800 text-white' : 'bg-white'}`}>
        <h3 className="font-semibold mb-4">Итого</h3>

        <div className="flex justify-between mb-2">
          <span>Товары:</span>
          <span>{calculateTotal().toLocaleString()} ₽</span>
        </div>

        <div className="flex justify-between mb-2">
          <span>Доставка:</span>
          <span>{calculateDeliveryPrice() > 0 ? `${calculateDeliveryPrice().toLocaleString()} ₽` : 'Бесплатно'}</span>
        </div>

        <div className="flex justify-between font-bold text-lg mt-4 pt-4 border-t border-gray-300">
          <span>К оплате:</span>
          <span>{(calculateTotal() + calculateDeliveryPrice()).toLocaleString()} ₽</span>
        </div>

        <div className="mt-4">
          <p><strong>Способ доставки:</strong> {
            formData.deliveryMethod === 'pickup' ? 'Самовывоз' :
              formData.deliveryMethod === 'courier' ? 'Доставка курьером' :
                'Доставка транспортной компанией'
          }</p>
          <p><strong>Способ оплаты:</strong> {getPaymentMethod()}</p>
        </div>
      </div>

      <div className="flex space-x-4">
        <button
          type="button"
          onClick={() => setCheckoutStep(0)}
          className={`flex-1 py-3 px-4 rounded-lg ${darkMode
            ? 'bg-gray-700 text-white hover:bg-gray-600'
            : 'bg-gray-200 text-gray-800 hover:bg-gray-300'
            }`}
        >
          Назад
        </button>

        <button
          type="submit"
          className="flex-1 py-3 px-4 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
        >
          Оформить заказ
        </button>
      </div>
    </form>
  );
};

export default CheckoutForm;